<template>
  <div class="order-status-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="statusOptions"
      display-by="Description"
      value-by="Id"
      :multiple="true"
      v-model="model"
      search-placeholder="Search status..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import { useOrderStatusStore } from '@/stores/OrderStatusStore';
import type { OrderStatusModel } from '@/models/OrderStatusModel';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Status' 
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const statusStore = useOrderStatusStore();
const statusOptions = ref<OrderStatusModel[]>([]);

// Load status options on mount
onMounted(async () => {
  await statusStore.load();
  // Convert Record to Array
  statusOptions.value = Object.values(statusStore.list) || [];
});

const handleChange = (value: number[]) => {
  emit('change', value);
};
</script>
